import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AntiqryCurrencyPipe } from '../pipes/antiqry-currency.pipe';
import { TranslatePipe } from '../pipes/translate.pipe';
import { ToDatePipe } from '../pipes/to-date.pipe';

@NgModule({
  declarations: [
    AutocompleteComponent,
  ],
  imports: [
    CommonModule,
    AntiqryCurrencyPipe,
    TranslatePipe,
    ToDatePipe,
    GooglePayButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule
  ],
  exports: [
    AutocompleteComponent,
    AntiqryCurrencyPipe,
    TranslatePipe,
    ToDatePipe,
    GooglePayButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule
  ]
})
export class SharedModule { }
